import Chart from 'chart.js'
import constants from '@/constants'

Chart.defaults.global.animation.duration = 500
// Chart.defaults.global.maintainAspectRatio = false
Chart.pluginService.register({
  beforeDraw: function(chart) {
    if (chart.options.centerText) {
      var width = chart.chart.width,
        height = chart.chart.height,
        ctx = chart.chart.ctx
      var legendHeight = 0
      if (chart.legend) legendHeight = chart.legend.height
      var labelHeight = 11

      ctx.restore()
      if (chart.options.centerText.label) {
        var labelFontSize = (height / 124).toFixed(2)
        ctx.font = 18 + 'px Proxima Nova'
        ctx.textBaseline = 'middle'

        ctx.fillStyle = constants.colors.theme.primaryLight5
        var label = chart.options.centerText.label,
          labelX = Math.round((width - ctx.measureText(label).width) / 2),
          labelY = height / 2 - legendHeight / 2
        if (chart.options.centerText.score !== null) {
          labelY = height / 2 - legendHeight / 2 - labelHeight
        }

        ctx.fillText(label, labelX, labelY)
      }

      if (chart.options.centerText.score !== null) {
        var scoreFontSize = (height / 114).toFixed(2)
        ctx.font = 18 + 'px Proxima Nova'
        ctx.textBaseline = 'middle'
        ctx.fillStyle = constants.colors.theme.primaryLight1

        var score = chart.options.centerText.score,
          scoreX = Math.round((width - ctx.measureText(score).width) / 2),
          scoreY = height / 2 - legendHeight / 2

        if (chart.options.centerText.label !== null) {
          scoreY = height / 2 - legendHeight / 2 + labelHeight
        }

        ctx.fillText(score, scoreX, scoreY)
      }

      ctx.save()
    }
  }
})

var customTooltips = function(tooltip) {
  // Tooltip Element
  var tooltipEl = document.getElementById('chartjs-tooltip')

  if (!tooltipEl) {
    tooltipEl = document.createElement('div')
    tooltipEl.id = 'chartjs-tooltip'
    tooltipEl.innerHTML = '<table id="chartjs-tooltip-table"></table>'
    this._chart.canvas.parentNode.appendChild(tooltipEl)
  }

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0
    return
  }

  // Set caret Position
  tooltipEl.classList.remove('above', 'below', 'no-transform')
  if (tooltip.yAlign) {
    tooltipEl.classList.add(tooltip.yAlign)
  } else {
    tooltipEl.classList.add('no-transform')
  }

  function getBody(bodyItem) {
    return bodyItem.lines
  }

  // Set Text
  if (tooltip.body) {
    var titleLines = tooltip.title || []
    var bodyLines = tooltip.body.map(getBody)

    var innerHtml = '<thead>'

    titleLines.forEach(function(title) {
      innerHtml += '<tr><th>' + title + '</th></tr>'
    })
    innerHtml += '</thead><tbody>'

    bodyLines.forEach(function(body, i) {
      var colors = tooltip.labelColors[i]
      var style = 'background:' + colors.backgroundColor
      style += '; border-color:' + colors.borderColor
      style += '; border-width: 2px'
      var span =
        '<span class="chartjs-tooltip-key" style="' + style + '"></span>'
      innerHtml += '<tr><td>' + span + body + '</td></tr>'
    })
    innerHtml += '</tbody>'

    var tableRoot = tooltipEl.querySelector('table')
    tableRoot.innerHTML = innerHtml
  }

  var positionY = this._chart.canvas.offsetTop
  var positionX = this._chart.canvas.offsetLeft

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1
  tooltipEl.style.left = positionX + tooltip.caretX + 'px'
  tooltipEl.style.top = positionY + tooltip.caretY + 'px'
  tooltipEl.style.fontFamily = tooltip._bodyFontFamily
  tooltipEl.style.fontSize = tooltip.bodyFontSize  + 'px'
  tooltipEl.style.fontStyle = tooltip._bodyFontStyle
  tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px'
  tooltipEl.style.position = 'absolute'
}

Chart.defaults.global.tooltips.enabled = false
Chart.defaults.global.tooltips.custom = customTooltips
// Chart.defaults.global.tooltips.backgroundColor = '#fff'
// Chart.defaults.global.tooltips.titleFontColor =
//   constants.colors.theme.primaryLight1
// Chart.defaults.global.tooltips.bodyFontColor =
//   constants.colors.theme.primaryLight1
//
Chart.defaults.global.tooltips.callbacks.label = function(item, data) {
  console.log(item, data)
  let base =
    data.datasets[item.datasetIndex].label + ': <b>' + item.value + '%</b>'

  if (data.datasets[item.datasetIndex].counts)
    base += '(' + data.datasets[item.datasetIndex].counts[item.index] + ')'
  return base
}

import {
  VueCharts,
  Bar,
  HorizontalBar,
  Doughnut,
  Line,
  Pie,
  PolarArea,
  Radar,
  Bubble,
  Scatter,
  mixins,
  generateChart
} from 'vue-chartjs'
export {
  VueCharts,
  Bar,
  HorizontalBar,
  Doughnut,
  Line,
  Pie,
  PolarArea,
  Radar,
  Bubble,
  Scatter,
  mixins,
  generateChart
}
